import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import { UserContext } from "./context/userContext"
import { Route, Routes, Navigate } from "react-router-dom"
import { connect } from "react-redux"
import axios from "axios"

// Import components and routes
import { userRoutes, authRoutes } from "./routes/allRoutes"
import Authmiddleware from "./routes/middleware/Authmiddleware"
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import Loader from "./components/Loader/Loader"
import "./assets/scss/theme.scss"
import fakeBackend from "./helpers/AuthType/fakeBackend"
import { JobProvider } from './context/jobContext';
import { NotifContext } from './context/notifContext';

import "./assets/css/style.css"
import "./assets/css/style2.css"

fakeBackend()

const App = props => {
  const [userData, setUserData] = useState(null)
  const [notifData, setNotifData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      setLoading(false)
      return
    }

    const getUserData = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL
        const response = await axios.get(`${baseUrl}/api/user`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        })
        setUserData(response.data)
        setError(null)
      } catch (err) {
        setError(err)
        localStorage.removeItem('access_token')
        setUserData(null)
      } finally {
        setLoading(false)
      }
    }
    const getNotifData = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL
        const response = await axios.get(`${baseUrl}/api/get-notifications?key=all`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        })
        setNotifData(response.data)
        setError(null)
      } catch (err) {
        setError(err)
        // localStorage.removeItem('access_token')
        setNotifData(null)
      } finally {
        setLoading(false)
      }
    }

    getUserData()
    getNotifData()
  }, [])

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()

  if (loading) {
    return <Loader /> // Show loading spinner while checking auth
  }

  return (
    <UserContext.Provider value={{ userData, loading, error, setUserData }}>
      <JobProvider>
        <NotifContext.Provider value={{ notifData, loading, error, setNotifData }}>
        <Routes>
          {/* Public routes */}
          {authRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            />
          ))}

          {/* Protected routes */}
          {userRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
            />
          ))}

          {/* Catch-all route for unauthorized access */}
          <Route
            path="*"
            element={<Navigate to={userData ? "/dashboard" : "/login"} />}
          />
        </Routes>
        </NotifContext.Provider>
      </JobProvider>
    </UserContext.Provider>
  )
}
App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
